import { Navigate, useLocation } from "react-router-dom";

import { Route } from "~services/router/Route";
import { storePostLoginRedirect } from "~utils/auth/postLoginRedirect";

/** @deprecated We are phasing out `components/**` */
export const RedirectToLogin = () => {
  const location = useLocation();
  const shouldRememberDestination = location.pathname !== Route.index() && location.pathname !== Route.login();

  if (shouldRememberDestination) {
    storePostLoginRedirect(location);
  }

  return <Navigate replace state={shouldRememberDestination ? { from: location } : undefined} to={Route.login()} />;
};
